import { useMemo, useState } from 'react'
import { useApiListGroup, useApiListGroupUser } from '../../api-new/state/content'
import { ModalDialog } from '../component/modal-dialog'
import { TextFilter } from './text-filter'
import { ButtonPrimary } from '../component/button'

export const PermissionUserGroupModal = ({ target, userID, allowAdd, allowDelete, onClose, onClosed }) => {
  const [filter, updateFilter] = useState('')

  const apiListGroup = useApiListGroup()
  const apiListGroupUser = useApiListGroupUser()

  const filteredItems = useMemo(
    () => {
      let lowerFilter = filter.toLowerCase()
      return apiListGroup.items.filter(i => i.name.toLowerCase().includes(lowerFilter))
    },
    [apiListGroup.items, filter]
  )

  const handleOpen = () => {
    updateFilter('')
    apiListGroup.get()
    apiListGroupUser.get(`${userID}/user`)
  }

  const handleClose = () => onClose && onClose()

  const handleAdd = async groupID => {
    await apiListGroupUser.post({ groupID: groupID, userID: userID })
    await apiListGroupUser.get(`${userID}/user`)
  }

  const handleRemove = async groupID => {
    await apiListGroupUser.delete(`${groupID}/${userID}`)
    await apiListGroupUser.get(`${userID}/user`)
  }

  return (
    <ModalDialog target={target} header="Add Group" fullScreen onOpen={handleOpen} onClose={onClosed}>
      <div className="d-flex flex-column h-100">
        <div>
          <TextFilter value={filter} onChange={updateFilter} />
        </div>
        <div className="flex-fill overflow-auto p-2">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 50 }} />
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((group, i) =>
                  <Item
                    key={i}
                    group={group}
                    selectedGroupUsers={apiListGroupUser.items}
                    allowAdd={allowAdd}
                    allowDelete={allowDelete}
                    onAdd={handleAdd}
                    onRemove={handleRemove}
                  />
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pt-1 border-top">
          <ButtonPrimary onClick={handleClose}>close</ButtonPrimary>
        </div>
      </div>
    </ModalDialog>
  )
}

const Item = ({ group, selectedGroupUsers, allowAdd, allowDelete, onAdd, onRemove }) => {
  const isChecked = useMemo(() => selectedGroupUsers.findIndex(selectedGroupUser => selectedGroupUser.groupID === group.id) !== -1, [group, selectedGroupUsers])

  const handleClick = () => {
    if (isChecked) {
      allowDelete && onRemove && onRemove(group.id)
    } else {
      allowAdd && onAdd && onAdd(group.id)
    }
  }

  return (
    <tr style={{ cursor: 'pointer' }} onClick={handleClick}>
      <td>
        <input className="form-check-input" type="checkbox" checked={isChecked} onChange={() => {}} />
      </td>
      <td>
        {group.name}
      </td>
    </tr>
  )
}
